// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__oEed5","label":"styles_label___Aj_W","caption":"styles_caption__JdPxU","description":"styles_description__PEq1H","content":"styles_content__l02yq"};